module.exports = __webpack_public_path__ + "img/arrowOutlineRightOrienIcon.d8bb331c.svg";